import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
// import { useWeb3Modal } from '@web3modal/wagmi/react';
import WalletConnectWalletInfo from '../WalletInfo/WalletConnectWalletInfo';
import { extractAddress } from '../helper';
import { useWagmiConfig } from '../../../../WalletConnectContext';
import { useAppKit } from "@reown/appkit/react";
import { useAccount, useWalletClient } from 'wagmi';
import { useDisconnect } from "@reown/appkit/react";
import { TRON_PLATFORM_TYPE } from '../../../../Constants/MainKeys';
import CheckYourNetworkModal from './CheckYourNetworkModal';

export default function WalletConnectWalletConfig({
  allBalance,
  selectedChain,
  selectedToken,
  setAddress,
}) {
  // Early return if Tron network is selected - this component should not render for Tron
  if (selectedChain?.platformType === TRON_PLATFORM_TYPE) {
    return null;
  }

  const { disconnect } = useDisconnect();
  const config = useWagmiConfig();
  const { open: openModal, close: closeModal, } = useAppKit();
  const { address, isConnected } = useAccount();
  const { status } = useWalletClient();

  const [isShowModal, setIsShowModal] = useState(false);

  useEffect(() => {
    if (address) {
      setAddress(address);
    }
  }, [address])

  const _disconnect = async () => {
    await disconnect();
    setAddress("");
  }

  const handleClose = () => {
    setIsShowModal(false);
    openModal();
  }

  return (
    <div>
      <CheckYourNetworkModal
        isShowModal={isShowModal}
        handleClose={handleClose}
        selectedChain={selectedChain}
      />
      <div className="title-block">
        <strong >
          {
            address ? `Wallet address ${extractAddress(address)}` : " Connect your wallet"
          }
        </strong>
      </div>
      <div className='mt-3'>
        <div className="p-3 text-dark">
          {
            !address ?
              <div>
                <p className='mb-4 wallet-info-text'>
                  You have selected a network and token. Now, connect your wallet using a secure connection via WalletConnect. This method supports both mobile and desktop wallets, allowing you to quickly interact with the selected network.
                  <br />To proceed press the <b>Connect Wallet</b> button below.
                </p>
                <Button variant="primary w-100 shadow" onClick={() => setIsShowModal(true)}>Connect Wallet</Button>
                {/* <appkit-button /> */}
              </div> :
              <div>
                {/* <w3m-button balance loadingLabel /> */}
                <WalletConnectWalletInfo
                  allBalance={allBalance}
                  selectedChain={selectedChain}
                  selectedToken={selectedToken}
                />
                <div className="d-flex justify-content-end mt-3">
                  <Button size='sm' variant="danger" onClick={_disconnect}>Disconnect Wallet</Button>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  )
}

